module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1031.3e9cf8d5.png";